<template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <div class="card">
            <div class="card-header">
                <h5>Your Saved Payment Methods</h5>
            </div>
            <div class="card-divider"></div>
            <div class="card-body card-body--padding--2">
                <div class="vehicles-list vehicles-list--layout--account">
                    <div class="vehicles-list__body">
                        <account-payment-list-item
                            v-for="(card, index) in savedcards"
                            :key="index"
                            :index="index"
                            :carddata="card"
                            @remove-card="removeCard"
                        >
                        </account-payment-list-item>

                        <!-- <div class="vehicles-list__item">
                            <div class="vehicles-list__item-info">                                                    
                                <strong><div class="vehicles-list__item-details">Mastercard ending in 7843</div></strong>
                                <div class="vehicles-list__item-details">Expiration: 06/2023</div>
                            </div>
                            <button type="button" class="vehicles-list__item-remove">
                                <svg width="16" height="16">
                                    <path d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z" />
                                </svg>
                            </button>
                        </div>
                        <div class="vehicles-list__item">
                            <div class="vehicles-list__item-info">                                                    
                                <strong><div class="vehicles-list__item-details">Mastercard ending in 8942</div></strong>
                                <div class="vehicles-list__item-details">Expiration: 08/2025</div>
                            </div>
                            <button type="button" class="vehicles-list__item-remove">
                                <svg width="16" height="16">
                                    <path d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z" />
                                </svg>
                            </button>
                        </div>
                        <div class="vehicles-list__item">
                            <div class="vehicles-list__item-info">                                                    
                                <strong><div class="vehicles-list__item-details">Mastercard ending in 4571</div></strong>
                                <div class="text-credit-card-expired">Expiration: 06/2020</div>                                                </div>
                            <button type="button" class="vehicles-list__item-remove">
                                <svg width="16" height="16">
                                    <path d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z" />
                                </svg>
                            </button>
                        </div>                                             -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <base-dialog
        title="Confirm Delete"
        @close="cancelRemove"
        :open="selectedCardIndex != null"
    >
        <template #default>
            <p>Are you sure you want to remove this card?</p>
        </template>
        <template #actions>
            <button
                type="button"
                class="btn btn-sm btn-secondary mr-2"
                @click="cancelRemove"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="confirmRemove"
            >
                Ok
            </button>
        </template>
    </base-dialog>
</template>

<script>
import AccountPaymentListItem from './AccountPaymentListItem';

export default {
    name: "AccountPaymentList",
    components: {
        AccountPaymentListItem    
    },
    props: {
        savedcards: {
            type: Array,
            required: true
        }
    },
    emits: ['confirm-remove'],
    data() {
        return {
            selectedCardIndex: null
        }
    },
    methods: {
        removeCard(index) {
            this.selectedCardIndex = index;
        },
        confirmRemove() {
            this.$emit("confirm-remove", this.selectedCardIndex);
            this.selectedCardIndex = null;
        },
        cancelRemove() {
            this.selectedCardIndex = null;
        },
    },
};
</script>